// extracted by mini-css-extract-plugin
module.exports = {"magazineWrapper":"BlogLayout_magazineWrapper__2MRQJ","magazineContainer":"BlogLayout_magazineContainer__9Vcrq"};